function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.954 16.516l-.716.716a.506.506 0 01-.716 0L.648 9.358a.506.506 0 010-.716L8.522.768a.506.506 0 01.716 0l.716.716a.506.506 0 010 .715L4.168 7.988h12.826c.28 0 .506.226.506.506v1.012c0 .28-.227.506-.506.506H4.164l5.79 5.788a.506.506 0 010 .716z",
  fill: "currentColor"
})));